import * as protoMessages from '@/proto/Messages';

interface ProtoMessagePayload {
    type: string;
    data?: Uint8Array;
}

const ProtoService = {
    async deserializeProtoMessage(message: Blob): Promise<ProtoMessagePayload> {
        const reader = new FileReader();

        return new Promise(resolve => {
            reader.addEventListener('loadend', () => {
                try {
                    const coordinatorMsg = protoMessages.CoordinatorMessage.fromBinary(
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        new Uint8Array(reader.result)
                    );

                    resolve({
                        type: coordinatorMsg.messageTypeStr,
                        data: coordinatorMsg.messageContent,
                    });
                } catch (error: any) {
                    console.error(`Caught exception: ${error.toString()}`);

                    resolve({ type: 'unknown' });
                }
            });

            reader.readAsArrayBuffer(message);
        });
    },

    serializeProtoMessage(payload: ProtoMessagePayload) {
        const message = protoMessages.CoordinatorMessage.create();

        message.messageTypeStr = payload.type;
        message.messageContent = <Uint8Array>payload.data;

        return protoMessages.CoordinatorMessage.toBinary(message);
    },

    deserializeGeneralProtoMessage(message: any) {
        const generalMessage = protoMessages.GeneralMessage.fromBinary(message);

        return {
            type: generalMessage.messageType?.value,
            data: generalMessage,
        };
    },
};

export default ProtoService;
